module.exports = __webpack_public_path__ + "img/move07.17058803.jpg";